<template>
  <v-dialog v-model="shareDialogShow" max-width="600" class="image-popup">
    <template #activator="{ on }">
      <v-btn
        v-if="viewMode === 'Default'"
        right
        color="primary"
        class="mr-2"
        v-on="on"
      >
        Share
        <v-icon right class="material-icons">share</v-icon>
      </v-btn>
      <v-btn v-if="viewMode === 'IconMode'" icon v-on="on">
        <v-icon
          :class="{
            'secondary--text': hasShares,
            'primary--text': !hasShares,
          }"
          :size="30"
          >share</v-icon
        >
      </v-btn>
    </template>
    <v-btn
      color="primary"
      icon
      class="popup-close"
      @click="shareDialogShow = false"
    >
      <v-icon>mdi-close-circle-outline</v-icon>
    </v-btn>
    <v-card>
      <div class="diaog-inner pa-10 grey lighten-5">
        <v-card-title>Share collection</v-card-title>

        <v-card-text>
          <v-form>
            <v-autocomplete
              v-model="shareWith"
              :loading="isLoading"
              :search-input.sync="search"
              :items="shareableClients"
              item-text="name"
              item-value="id"
              label="Share with"
              filled
              dense
              flat
            ></v-autocomplete>

            <v-btn color="primary" class="mt-2" @click="doShare">Share</v-btn>
          </v-form>

          <v-form class="mt-2">
            <v-select
              v-model="unShareWith"
              :items="sharedWithClients"
              item-text="name"
              item-value="id"
              label="Unshare with user"
              class="mb-3"
              clearable
              filled
              dense
              solo
              hide-details
              flat
            ></v-select>

            <v-btn id="unshare" color="primary" small @click="doUnShare()">
              Unshare
            </v-btn>
          </v-form>
        </v-card-text>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";

import { FETCH_COLLECTION, COLLECTION_SET_BY_OBJ } from "@/store/actions.type";
import ApiService from "@/common/api.service";
import toast from "@/services/toast";

export default {
  name: "ShareDialog",
  props: {
    collectionId: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: null,
    },
    iconMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    shareDialogShow: false,
    shareWith: null,
    unShareWith: null,
    activeCollection: {},

    response: {},
    isLoading: false,
    search: null,
    shareableClients: [],

    lastSearch: "",
  }),
  computed: {
    viewMode() {
      if (
        this.currentUser.permissions.can_share_collections &&
        this.activeCollection.is_collection_sharable
      ) {
        if (this.iconMode) {
          return "IconMode";
        }
        return "Default";
      }
      return false;
    },
    hasShares() {
      if (
        this.activeCollection.shared_with_clients &&
        this.activeCollection.shared_with_clients.length &&
        this.activeExpClient.id === this.activeCollection.owner.id
      ) {
        return true;
      }
      return false;
    },

    activeCollectionId() {
      if (this.$route.params.collectionId) {
        return this.$route.params.collectionId;
      }
      if (this.collectionId) {
        return this.collectionId;
      }
      return null;
    },
    sharedWithClients() {
      if (this.activeCollection.shared_with_clients) {
        return this.activeCollection.shared_with_clients;
      }
      return [];
    },
    ...mapGetters([
      "collections",
      "collection",
      "activeExpClient",
      "currentUser",
    ]),
  },
  watch: {
    shareDialogShow(val) {
      this.shareWith = null;
      this.unShareWith = null;
      if (val) {
        this.getClientList();
      }
    },
    collection(val) {
      if (this.index === null) {
        console.log("WATCH");
        this.activeCollection = val;
      }
    },
    search(val) {
      if (val !== this.lastSearch) {
        this.isLoading = true;
        this.getClientList()
          .then(() => {
            this.isLoading = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    if (this.index !== null) {
      console.log("seting from index");
      this.activeCollection = this.collections[this.index];
    } else if (this.collection) {
      console.log("seting from vuex");

      this.activeCollection = this.collection;
    }
  },
  methods: {
    // Wrapper function for shareAction
    doUnShare() {
      this.shareAction(false);

      this.activeCollection.shared_with_clients = this.activeCollection.shared_with_clients.filter(
        (t) => t.id !== this.unShareWith
      );
      this.$store.dispatch(COLLECTION_SET_BY_OBJ, this.activeCollection);
    },
    // Wrapper function for shareAction
    doShare() {
      this.shareAction();
      const shares = this.shareableClients.filter(
        (t) => t.id === this.shareWith
      );

      this.activeCollection.shared_with_clients = this.activeCollection.shared_with_clients.concat(
        shares
      );
      this.$store.dispatch(COLLECTION_SET_BY_OBJ, this.activeCollection);
    },
    /**
     * Undocumented function
     *
     * @param {bool} shareIsActive if false deactivate share.
     * @return void
     */
    shareAction(shareIsActive = true) {
      this.isLoading = true;

      const toClientId = shareIsActive ? this.shareWith : this.unShareWith;

      console.log(shareIsActive, toClientId);
      return ApiService.post("/collections/share-service", {
        client_id: this.activeExpClient.id,
        collection_id: this.activeCollectionId,
        to_client_id: toClientId,
        share_is_active: shareIsActive,
      })
        .then(({ data }) => {
          this.users = data.data;
          toast.success(data.message);

          this.isLoading = false;
          this.getClientList();
          this.getClientList(true);
        })
        .catch((error) => {
          console.log(error);
          return { error: true };
        });
    },

    /**
     * Get list clients to share or unshare.
     *
     * @param {bool} sharedWith If true returns shared with.
     * @return void
     */
    getClientList() {
      const params = {
        params: {
          collection_id: this.activeCollectionId,
          client_id: this.activeExpClient.id,
          where_has_collections: 0,
          page: 1,
          per_page: 25,
        },
      };
      if (this.search) {
        params.params.search = this.search;
      }
      return new Promise((resolve) => {
        ApiService.query("/user/permitted-clients", params)
          .then(({ data }) => {
            this.shareableClients = data.data;
            resolve(data);
          })
          .catch((error) => {
            console.log(error);
            return { error: true };
          });
      });
    },

    setCollection() {
      store
        .dispatch(FETCH_COLLECTION, {
          clientId: this.$route.params.clientId,
          collectionId: this.activeCollectionId,
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
